import { MessageBar, MessageBarType } from "@fluentui/react";
import { useEffect } from "react";

export interface IBwjToastProps {
  type: MessageBarType;
  message: string;
  multiline: boolean;
  onDismiss: () => void;
  autoDismissTime?: number;
  dismissButtonAriaLabel?: string;
}

export const BwjToast: React.FC<IBwjToastProps> = ({ type, message, multiline, onDismiss, dismissButtonAriaLabel, autoDismissTime = null }) => {
  useEffect(() => {
    let timeoutId: number | undefined;
    if (autoDismissTime !== null && autoDismissTime !== undefined) {
        window.setTimeout(() => {
            onDismiss();
        }, autoDismissTime);
    }

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [autoDismissTime, onDismiss]);
  
    return (
      <>
        {message && (
          <div
            style={{
              position: 'fixed', 
              bottom: 60, 
              maxWidth: 600, 
              left: 'calc( 50% + 110px)', 
              transform: 'translateX(-50%)', 
              zIndex: 2
            }}
          >
            <MessageBar
              messageBarType={type}
              isMultiline={multiline}
              onDismiss={onDismiss}
              dismissButtonAriaLabel={dismissButtonAriaLabel ?? 'Close'}
            >
              {message}
            </MessageBar>
          </div>
        )}
      </>
    );
  };